import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.collab.task');
import { OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

interface BoardColumn { key: string; title: string; color: string; }
interface Task {
    id: string; title: string; status: string; priority: string;
    progress: number; assignees: string[]; tags: string[];
    due_at?: string; start_at?: string; description?: string;
    order: number; created: string; created_by: string;
}

@Component({
    selector: 'wiz-portal-lpsysadmin-collab-task',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.collab.task/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCollabTaskComponent implements OnInit, OnChanges {
    constructor(@Inject( Service) public service: Service) { }

    @Input() workspace_id: string = '';
    @Input() view: string = 'board';     // board | list | gantt
    @Input() task_id: string = '';

    public ws: any = null;
    public board: any = null;
    public columns: BoardColumn[] = [];
    public tasks: Task[] = [];
    public stats: any = { total: 0, done: 0, in_progress: 0, overdue: 0 };
    public loaded: boolean = false;
    public workspaces: any[] = [];

    public viewTabs = [
        { key: 'board', title: '칸반' },
        { key: 'list', title: '리스트' },
        { key: 'gantt', title: '간트' },
    ];

    // filters
    public filterText: string = '';
    public filterAssignee: string = '';
    public filterPriority: string = '';
    public members: any[] = [];

    // modals
    public showCreate: boolean = false;
    public newTask: any = { title: '', status: 'todo', priority: 'normal', description: '', tags: [] };
    public newTagInput: string = '';

    public showDetail: boolean = false;
    public detailTask: any = null;
    public detailComments: any[] = [];
    public detailChecklists: any[] = [];
    public newComment: string = '';
    public newChecklistTitle: string = '';

    // drag-and-drop
    public draggingTask: Task | null = null;

    public priorities = [
        { key: 'urgent', title: '긴급', color: 'rose' },
        { key: 'high', title: '높음', color: 'amber' },
        { key: 'normal', title: '보통', color: 'zinc' },
        { key: 'low', title: '낮음', color: 'blue' },
    ];

    public async ngOnInit() {
        await this.service.init();
        this.view = this.view || 'board';
        await this.load();
        if (this.task_id) {
            await this.openDetail({ id: this.task_id });
        }
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (changes['workspace_id'] && !changes['workspace_id'].firstChange) {
            await this.load();
        }
        if (changes['task_id'] && this.task_id && !changes['task_id'].firstChange) {
            await this.openDetail({ id: this.task_id });
        }
    }

    public async load() {
        if (!this.workspace_id) {
            const r = await wiz.call("workspaces", {});
            if (r.code === 200) this.workspaces = r.data.workspaces || [];
            this.loaded = true;
            await this.service.render();
            return;
        }
        const res = await wiz.call("init", { workspace_id: this.workspace_id });
        if (res.code === 200) {
            this.ws = res.data.workspace;
            this.board = res.data.board;
            this.columns = (this.board && this.board.columns) || [];
            this.members = res.data.members || [];
            this.tasks = res.data.tasks || [];
            this.stats = res.data.stats || this.stats;
        } else if (res.code === 403) {
            this.service.alert.error("접근 권한이 없습니다.");
        } else {
            this.service.alert.error(res.data?.message || "로드 실패");
        }
        this.loaded = true;
        await this.service.render();
    }

    public switchView(v: string) {
        this.view = v;
        this.service.render();
    }

    public selectWorkspace(ws: any) {
        this.service.href(`/admin/collab/task/${ws.id}/board`);
    }

    public tasksFor(colKey: string): Task[] {
        return this.filteredTasks().filter(t => t.status === colKey);
    }

    public filteredTasks(): Task[] {
        let rows = this.tasks;
        if (this.filterText) {
            const t = this.filterText.toLowerCase();
            rows = rows.filter(r => (r.title || '').toLowerCase().includes(t));
        }
        if (this.filterAssignee) {
            rows = rows.filter(r => (r.assignees || []).indexOf(this.filterAssignee) >= 0);
        }
        if (this.filterPriority) {
            rows = rows.filter(r => r.priority === this.filterPriority);
        }
        return rows;
    }

    public memberName(uid: string): string {
        const m = this.members.find(x => x.user_id === uid);
        return m ? m.name : uid;
    }

    public initials(uid: string): string {
        const n = this.memberName(uid) || '?';
        return n.charAt(0);
    }

    public priorityColor(p: string): string {
        const it = this.priorities.find(x => x.key === p);
        return it ? it.color : 'zinc';
    }

    public columnColor(key: string): string {
        const c = this.columns.find(x => x.key === key);
        return c ? c.color : 'zinc';
    }

    public columnTitle(key: string): string {
        const c = this.columns.find(x => x.key === key);
        return c ? c.title : key;
    }

    // -------- Create --------
    public openCreate(status: string = 'todo') {
        this.showCreate = true;
        this.newTask = { title: '', status, priority: 'normal', description: '', tags: [] };
        this.newTagInput = '';
    }

    public closeCreate() {
        this.showCreate = false;
    }

    public addTag() {
        const t = (this.newTagInput || '').trim();
        if (!t) return;
        if (this.newTask.tags.indexOf(t) < 0) this.newTask.tags.push(t);
        this.newTagInput = '';
    }

    public removeTag(t: string) {
        this.newTask.tags = this.newTask.tags.filter((x: string) => x !== t);
    }

    public async create() {
        if (!this.newTask.title || !this.newTask.title.trim()) {
            this.service.alert.error("제목을 입력하세요.");
            return;
        }
        const res = await wiz.call("create", {
            workspace_id: this.workspace_id,
            board_id: this.board.id,
            title: this.newTask.title,
            description: this.newTask.description || '',
            status: this.newTask.status,
            priority: this.newTask.priority,
            tags: JSON.stringify(this.newTask.tags || []),
            due_at: this.newTask.due_at || '',
        });
        if (res.code === 200) {
            this.showCreate = false;
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || "생성 실패");
        }
    }

    // -------- Detail --------
    public async openDetail(task: any) {
        const res = await wiz.call("info", { id: task.id });
        if (res.code === 200) {
            this.detailTask = res.data.task;
            this.detailComments = res.data.comments || [];
            this.detailChecklists = res.data.checklists || [];
            this.showDetail = true;
            await this.service.render();
        } else {
            this.service.alert.error(res.data?.message || "상세 로드 실패");
        }
    }

    public closeDetail() {
        this.showDetail = false;
        this.detailTask = null;
    }

    public async saveDetail() {
        const res = await wiz.call("update", {
            id: this.detailTask.id,
            title: this.detailTask.title,
            description: this.detailTask.description || '',
            status: this.detailTask.status,
            priority: this.detailTask.priority,
            due_at: this.detailTask.due_at || '',
            assignees: JSON.stringify(this.detailTask.assignees || []),
            tags: JSON.stringify(this.detailTask.tags || []),
        });
        if (res.code === 200) {
            this.service.alert.success("저장됨");
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || "저장 실패");
        }
    }

    public async toggleAssignee(uid: string) {
        const arr = this.detailTask.assignees || [];
        const idx = arr.indexOf(uid);
        if (idx >= 0) arr.splice(idx, 1); else arr.push(uid);
        this.detailTask.assignees = [...arr];
        await this.service.render();
    }

    public async deleteDetail() {
        const ok = await this.service.alert.show({
            title: "업무 삭제",
            message: "업무와 댓글·체크리스트를 모두 삭제합니다.",
            actionBtn: "danger", action: "삭제", cancel: "취소",
        });
        if (!ok) return;
        const res = await wiz.call("delete", { id: this.detailTask.id });
        if (res.code === 200) {
            this.closeDetail();
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || "삭제 실패");
        }
    }

    public async addComment() {
        const c = (this.newComment || '').trim();
        if (!c) return;
        const res = await wiz.call("comment_add", { task_id: this.detailTask.id, content: c });
        if (res.code === 200) {
            this.newComment = '';
            await this.openDetail(this.detailTask);
        }
    }

    public async deleteComment(cid: string) {
        const res = await wiz.call("comment_delete", { id: cid });
        if (res.code === 200) {
            this.detailComments = this.detailComments.filter(c => c.id !== cid);
            await this.service.render();
        }
    }

    public async addChecklist() {
        const t = (this.newChecklistTitle || '').trim();
        if (!t) return;
        const res = await wiz.call("checklist_add", { task_id: this.detailTask.id, title: t });
        if (res.code === 200) {
            this.newChecklistTitle = '';
            await this.openDetail(this.detailTask);
        }
    }

    public async toggleChecklist(c: any) {
        const res = await wiz.call("checklist_toggle", { id: c.id });
        if (res.code === 200) {
            c.checked = res.data.checked;
            // reload detail for progress refresh
            await this.openDetail(this.detailTask);
        }
    }

    public async deleteChecklist(c: any) {
        const res = await wiz.call("checklist_delete", { id: c.id });
        if (res.code === 200) await this.openDetail(this.detailTask);
    }

    // -------- Drag & Drop (Kanban) --------
    public dragStart(t: Task, ev: any) {
        this.draggingTask = t;
        ev.dataTransfer.effectAllowed = 'move';
    }

    public dragOver(ev: any) { ev.preventDefault(); ev.dataTransfer.dropEffect = 'move'; }

    public async drop(colKey: string, ev: any) {
        ev.preventDefault();
        if (!this.draggingTask) return;
        if (this.draggingTask.status === colKey) {
            this.draggingTask = null;
            return;
        }
        const t = this.draggingTask;
        this.draggingTask = null;
        // optimistic
        t.status = colKey;
        await this.service.render();
        await wiz.call("move", { id: t.id, status: colKey });
        await this.load();
    }

    // -------- Gantt helpers --------
    public ganttRows(): any[] {
        const rows = this.filteredTasks().filter(t => t.start_at || t.due_at);
        return rows;
    }

    public ganttRange(): any {
        const rows = this.ganttRows();
        if (rows.length === 0) {
            const now = new Date();
            const start = new Date(now.getFullYear(), now.getMonth(), 1);
            const end = new Date(now.getFullYear(), now.getMonth() + 2, 0);
            return { start, end };
        }
        let min: Date | null = null, max: Date | null = null;
        rows.forEach(r => {
            const s = r.start_at ? new Date(r.start_at) : (r.due_at ? new Date(r.due_at) : null);
            const e = r.due_at ? new Date(r.due_at) : (r.start_at ? new Date(r.start_at) : null);
            if (s && (!min || s < min)) min = s;
            if (e && (!max || e > max)) max = e;
        });
        if (!min) min = new Date();
        if (!max) max = new Date(min.getTime() + 30 * 86400000);
        // pad
        min = new Date(min.getTime() - 3 * 86400000);
        max = new Date(max.getTime() + 3 * 86400000);
        return { start: min, end: max };
    }

    public ganttDays(): Date[] {
        const r = this.ganttRange();
        const days: Date[] = [];
        let d = new Date(r.start);
        while (d <= r.end) {
            days.push(new Date(d));
            d.setDate(d.getDate() + 1);
        }
        return days;
    }

    public ganttBar(t: any): any {
        const r = this.ganttRange();
        const total = (r.end.getTime() - r.start.getTime()) / 86400000;
        const s = t.start_at ? new Date(t.start_at) : new Date(t.due_at);
        const e = t.due_at ? new Date(t.due_at) : new Date(t.start_at);
        const offset = (s.getTime() - r.start.getTime()) / 86400000;
        let span = (e.getTime() - s.getTime()) / 86400000 + 1;
        if (span < 1) span = 1;
        return {
            left: (offset / total) * 100 + '%',
            width: (span / total) * 100 + '%',
        };
    }

    public formatDay(d: Date): string {
        return (d.getMonth() + 1) + '/' + d.getDate();
    }
}

export default PortalLpsysadminCollabTaskComponent;